import React from 'react';
import PortComparisonChart from '../Charts/PortComparisonChart';
import { DrilldownDataService } from '../../services/DrilldownDataService';

const PortsTab = ({ selectedPort, handlePortChange, openDrillDown }) => {
  const ports = [
    { id: 'port1', name: 'Cohin Port', location: 'Cohin', volume: '185,430 T', vessels: '24', color: '#4da6ff', description: 'Leading in efficiency' },
    { id: 'port2', name: 'Kandla Port', location: 'Kandla', volume: '245,820 T', vessels: '32', color: '#ff6384', description: 'Highest volume' },
    { id: 'port3', name: 'Chennai Port', location: 'Chennai', volume: '142,580 T', vessels: '18', color: '#4cd964', description: 'Best in Europe' },
    { id: 'port4', name: 'Mangalore Port', location: 'Mangalore', volume: '98,750 T', vessels: '14', color: '#ff9f40', description: 'Fastest growing' },
    { id: 'port5', name: 'Mormugao Port', location: 'Goa', volume: '165,320 T', vessels: '22', color: '#9966ff', description: 'Top in Americas' }
  ];

  const portRankings = [
    { rank: 1, id: 'port1', name: 'Cohin Port', throughput: '185,430 T', efficiency: '94%', growth: '+12.5%' },
    { rank: 2, id: 'port2', name: 'Kandla Port', throughput: '245,820 T', efficiency: '92%', growth: '+8.7%' },
    { rank: 3, id: 'port3', name: 'Chennai Port', throughput: '142,580 T', efficiency: '90%', growth: '+6.2%' },
    { rank: 4, id: 'port4', name: 'Mangalore Port', throughput: '165,320 T', efficiency: '88%', growth: '+5.8%' },
    { rank: 5, id: 'port5', name: 'Mormugao Port', throughput: '98,750 T', efficiency: '86%', growth: '+15.2%' }
  ];

  const getEfficiencyStatus = (efficiency) => {
    const eff = parseInt(efficiency);
    if (eff >= 90) return 'status-high';
    if (eff >= 85) return 'status-medium';
    return 'status-low';
  };

  const getGrowthStatus = (growth) => {
    const growthNum = parseFloat(growth);
    if (growthNum >= 10) return 'status-high';
    if (growthNum >= 5) return 'status-medium';
    return 'status-low';
  };

  // Handle port card click
  const handlePortClick = (port) => {
    if (openDrillDown) {
      const detailedData = DrilldownDataService.getPortDetails(port.id);
      openDrillDown('port', detailedData, `${port.name} Analysis`);
    }
    handlePortChange(port.id);
  };

  // Handle ranking row click
  const handleRankingClick = (port) => {
    if (openDrillDown) {
      const detailedData = DrilldownDataService.getPortDetails(port.id);
      openDrillDown('port', detailedData, `${port.name} Ranking Analysis`);
    }
  };

  return (
    <div id="ports-tab" className="tab-content-wrapper">
      <div className="ports-dashboard">
        <h3 className="section-title">
          <i className="fas fa-map"></i>
          <span>Multi-Port Performance Comparison</span>
        </h3>
        
        <div className="ports-grid">
          {ports.map(port => (
            <div 
              key={port.id}
              className={`port-card ${selectedPort === port.id ? 'active' : ''} clickable`}
              onClick={() => handlePortClick(port)}
            >
              <div className="port-card-header">
                <div className="port-icon" style={{backgroundColor: port.color}}>
                  <i className="fas fa-ship"></i>
                </div>
                <div>
                  <h4>{port.name}</h4>
                  <div className="port-location">{port.location}</div>
                </div>
              </div>
              <div className="port-stats">
                <div className="stat-item">
                  <div className="stat-value">{port.volume}</div>
                  <div className="stat-label">Monthly Volume</div>
                </div>
                <div className="stat-item">
                  <div className="stat-value">{port.vessels}</div>
                  <div className="stat-label">Vessels</div>
                </div>
              </div>
              <div className="card-change positive" style={{marginTop: '15px'}}>
                <i className="fas fa-arrow-up"></i>
                <span>{port.description}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <div className="charts-section">
        <div className="chart-container">
          <h3 className="section-title">
            <i className="fas fa-chart-bar"></i>
            <span>Port Performance Comparison</span>
          </h3>
          <div>
            <PortComparisonChart 
              onClick={() => openDrillDown && openDrillDown('port-comparison', {
                title: 'Port Performance Comparison',
                metrics: ['Throughput', 'Efficiency', 'Growth', 'Vessels'],
                insights: [
                  'Kandla leads in volume but lower efficiency',
                  'Cohin excels in efficiency and growth',
                  'Mormugao shows strongest growth rate'
                ],
                recommendations: ['Share best practices', 'Standardize metrics', 'Collaborate on operations']
              }, 'Port Comparison')}
            />
          </div>
        </div>
        
        <div className="table-container">
          <h3 className="section-title">
            <i className="fas fa-trophy"></i>
            <span>Port Ranking by Efficiency</span>
          </h3>
          <table className="data-table">
            <thead>
              <tr>
                <th>Rank</th>
                <th>Port</th>
                <th>Throughput</th>
                <th>Efficiency</th>
                <th>Growth</th>
              </tr>
            </thead>
            <tbody>
              {portRankings.map((port, index) => (
                <tr 
                  key={index} 
                  className={index === 0 ? 'highlight clickable-row' : 'clickable-row'}
                  onClick={() => handleRankingClick(port)}
                >
                  <td>{port.rank}</td>
                  <td><strong>{port.name}</strong></td>
                  <td>{port.throughput}</td>
                  <td><span className={`status-indicator ${getEfficiencyStatus(port.efficiency)}`}>{port.efficiency}</span></td>
                  <td><span className={`status-indicator ${getGrowthStatus(port.growth)}`}>{port.growth}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Additional Insights */}
      <div className="insights-container" style={{marginTop: '30px'}}>
        <div 
          className="insight-card clickable"
          onClick={() => openDrillDown && openDrillDown('volume-leader', {
            title: 'Volume Leader Analysis',
            content: 'Kandla Port handles 245,820 T monthly, 32.5% more than second-ranked Cohin Port.',
            details: 'Volume drivers:',
            drivers: [
              'Strategic location',
              'Bulk cargo specialization',
              'Infrastructure capacity',
              'Trade agreements'
            ],
            challenges: ['Efficiency improvement needed', 'Congestion issues']
          }, 'Volume Analysis')}
        >
          <div className="insight-title"><i className="fas fa-weight-hanging"></i> Volume Leadership</div>
          <div className="insight-content">Kandla Port handles highest volume at 245,820 T monthly, but ranks second in efficiency.</div>
        </div>
        
        <div 
          className="insight-card success clickable"
          onClick={() => openDrillDown && openDrillDown('efficiency-leader', {
            title: 'Efficiency Leader Analysis',
            content: 'Cohin Port leads in efficiency (94%) despite not having highest volume.',
            details: 'Efficiency factors:',
            factors: [
              'Advanced technology',
              'Skilled workforce',
              'Optimal operations',
              'Continuous improvement'
            ],
            bestPractices: ['Can be replicated across network']
          }, 'Efficiency Analysis')}
        >
          <div className="insight-title"><i className="fas fa-bolt"></i> Efficiency Excellence</div>
          <div className="insight-content">Cohin Port leads in operational efficiency (94%), demonstrating best practices for the network.</div>
        </div>
        
        <div 
          className="insight-card warning clickable"
          onClick={() => openDrillDown && openDrillDown('growth-leader', {
            title: 'Growth Leader Analysis',
            content: 'Mormugao Port shows strongest growth at +15.2%, indicating rapid expansion.',
            details: 'Growth drivers:',
            drivers: [
              'New infrastructure',
              'Market expansion',
              'Service improvements',
              'Strategic partnerships'
            ],
            sustainability: 'Need to ensure growth doesn\'t compromise efficiency'
          }, 'Growth Analysis')}
        >
          <div className="insight-title"><i className="fas fa-rocket"></i> Rapid Growth</div>
          <div className="insight-content">Mormugao Port shows strongest growth at +15.2%, indicating rapid expansion and market capture.</div>
        </div>
      </div>
    </div>
  );
};

export default PortsTab;